/**
 * Utility functions for handling color classes in the calendar feature
 */

type ColorClasses = {
  bg: string;
  bgDark: string;
  text: string;
  textDark: string;
  textLight: string;
  textLightDark: string;
};

/**
 * Maps a color name to corresponding Tailwind CSS classes
 * @param color The color name (e.g., 'sky', 'indigo', etc.)
 * @returns An object with Tailwind CSS classes for the specified color
 */
export const getColorClasses = (color: string): ColorClasses => {
  switch (color) {
    case 'sky':
      return {
        bg: 'bg-sky-100',
        bgDark: 'dark:bg-sky-900/30',
        text: 'text-sky-700',
        textDark: 'dark:text-sky-300',
        textLight: 'text-sky-600',
        textLightDark: 'dark:text-sky-400',
      };
    case 'indigo':
      return {
        bg: 'bg-indigo-100',
        bgDark: 'dark:bg-indigo-900/30',
        text: 'text-indigo-700',
        textDark: 'dark:text-indigo-300',
        textLight: 'text-indigo-600',
        textLightDark: 'dark:text-indigo-400',
      };
    case 'yellow':
      return {
        bg: 'bg-yellow-100',
        bgDark: 'dark:bg-yellow-900/30',
        text: 'text-yellow-700',
        textDark: 'dark:text-yellow-300',
        textLight: 'text-yellow-600',
        textLightDark: 'dark:text-yellow-400',
      };
    case 'green':
      return {
        bg: 'bg-green-100',
        bgDark: 'dark:bg-green-900/30',
        text: 'text-green-700',
        textDark: 'dark:text-green-300',
        textLight: 'text-green-600',
        textLightDark: 'dark:text-green-400',
      };
    case 'red':
      return {
        bg: 'bg-red-100',
        bgDark: 'dark:bg-red-900/30',
        text: 'text-red-700',
        textDark: 'dark:text-red-300',
        textLight: 'text-red-600',
        textLightDark: 'dark:text-red-400',
      };
    case 'purple':
      return {
        bg: 'bg-purple-100',
        bgDark: 'dark:bg-purple-900/30',
        text: 'text-purple-700',
        textDark: 'dark:text-purple-300',
        textLight: 'text-purple-600',
        textLightDark: 'dark:text-purple-400',
      };
    case 'orange':
      return {
        bg: 'bg-orange-100',
        bgDark: 'dark:bg-orange-900/30',
        text: 'text-orange-700',
        textDark: 'dark:text-orange-300',
        textLight: 'text-orange-600',
        textLightDark: 'dark:text-orange-400',
      };
    case 'pink':
      return {
        bg: 'bg-pink-100',
        bgDark: 'dark:bg-pink-900/30',
        text: 'text-pink-700',
        textDark: 'dark:text-pink-300',
        textLight: 'text-pink-600',
        textLightDark: 'dark:text-pink-400',
      };
    case 'teal':
      return {
        bg: 'bg-teal-100',
        bgDark: 'dark:bg-teal-900/30',
        text: 'text-teal-700',
        textDark: 'dark:text-teal-300',
        textLight: 'text-teal-600',
        textLightDark: 'dark:text-teal-400',
      };
    default:
      return {
        bg: 'bg-gray-100',
        bgDark: 'dark:bg-gray-800/30',
        text: 'text-gray-700',
        textDark: 'dark:text-gray-300',
        textLight: 'text-gray-600',
        textLightDark: 'dark:text-gray-400',
      };
  }
};
